"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bucketHostname = void 0;

var tslib_1 = require("tslib");

var DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var DOTS_PATTERN = /\.\./;
var DOT_PATTERN = /\./;
var S3_HOSTNAME_PATTERN = /^(.+\.)?s3[.-]([a-z0-9-]+)\./;
var S3_US_EAST_1_ALTNAME_PATTERN = /^s3(-external-1)?\.amazonaws\.com$/;
var AWS_PARTITION_SUFFIX = "amazonaws.com";

function bucketHostname(_a) {
  var _b = _a.accelerateEndpoint,
      accelerateEndpoint = _b === void 0 ? false : _b,
      baseHostname = _a.baseHostname,
      bucketName = _a.bucketName,
      _c = _a.dualstackEndpoint,
      dualstackEndpoint = _c === void 0 ? false : _c,
      _d = _a.pathStyleEndpoint,
      pathStyleEndpoint = _d === void 0 ? false : _d,
      _e = _a.tlsCompatible,
      tlsCompatible = _e === void 0 ? true : _e;

  if (!S3_HOSTNAME_PATTERN.test(baseHostname)) {
    return {
      bucketEndpoint: false,
      hostname: baseHostname
    };
  }

  var _f = tslib_1.__read(S3_US_EAST_1_ALTNAME_PATTERN.test(baseHostname) ? ["us-east-1", AWS_PARTITION_SUFFIX] : partitionSuffix(baseHostname), 2),
      region = _f[0],
      hostnameSuffix = _f[1];

  if (pathStyleEndpoint || !isDnsCompatibleBucketName(bucketName) || tlsCompatible && DOT_PATTERN.test(bucketName)) {
    return {
      bucketEndpoint: false,
      hostname: dualstackEndpoint ? "s3.dualstack." + region + "." + hostnameSuffix : baseHostname
    };
  }

  if (accelerateEndpoint) {
    baseHostname = "s3-accelerate" + (dualstackEndpoint ? ".dualstack" : "") + "." + hostnameSuffix;
  } else if (dualstackEndpoint) {
    baseHostname = "s3.dualstack." + region + "." + hostnameSuffix;
  }

  return {
    bucketEndpoint: true,
    hostname: bucketName + "." + baseHostname
  };
}

exports.bucketHostname = bucketHostname;
/**
 * Determines whether a given string is DNS compliant per the rules outlined by
 * S3. Length, capitaization, and leading dot restrictions are enforced by the
 * DOMAIN_PATTERN regular expression.
 *
 * @see https://docs.aws.amazon.com/AmazonS3/latest/dev/BucketRestrictions.html
 */

function isDnsCompatibleBucketName(bucketName) {
  return DOMAIN_PATTERN.test(bucketName) && !IP_ADDRESS_PATTERN.test(bucketName) && !DOTS_PATTERN.test(bucketName);
}

function partitionSuffix(hostname) {
  var parts = hostname.match(S3_HOSTNAME_PATTERN);
  return [parts[2], hostname.replace(new RegExp("^" + parts[0]), "")];
}